// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__191Xp","leftbox":"Footer_leftbox__2mNdu"};